var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/email-signup/email-signup-checkboxes.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<fieldset class=\"c-email-signup-checkboxes\">\n\n    <ul class=\"c-form-adjacent\">\n\n        <li class=\"c-form-adjacent__li\">\n\n            <input type=\"checkbox\"\n                   name=\"additional-brand-signup\"\n                   id=\"bhldn-checkbox\"\n                   class=\"c-form-adjacent__checkbox\"\n                   value=\"";
output += runtime.suppressValue((lineno = 10, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-bhldn-checkbox-value"])), env.opts.autoescape);
output += "\"\n                   checked>\n\n            <label for=\"bhldn-checkbox\" class=\"c-form-adjacent__label\">\n                ";
output += runtime.suppressValue((lineno = 14, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-bhldn-checkbox-label"])), env.opts.autoescape);
output += "\n            </label>\n\n        </li>\n\n        <li class=\"c-form-adjacent__li\">\n\n            <input type=\"checkbox\"\n                   name=\"additional-brand-signup\"\n                   id=\"terrain-checkbox\"\n                   class=\"c-form-adjacent__checkbox\"\n                   value=\"";
output += runtime.suppressValue((lineno = 25, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-terrain-checkbox-value"])), env.opts.autoescape);
output += "\"\n                   checked>\n\n            <label for=\"terrain-checkbox\" class=\"c-form-adjacent__label\">\n                ";
output += runtime.suppressValue((lineno = 29, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["email_signup-terrain-checkbox-label"])), env.opts.autoescape);
output += "\n            </label>\n\n        </li>\n\n    </ul>\n\n</fieldset>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/email-signup/email-signup-checkboxes.j2"] , dependencies)